import { render, staticRenderFns } from "./rgb.vue?vue&type=template&id=7e25b6aa&"
import script from "./rgb.vue?vue&type=script&lang=js&"
export * from "./rgb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports